/**
 * Token kotası göstergesi.
 *
 * Kota MERKEZÎ bir havuzdan geliyor (abonelik/CustomerProductId bazında) ve tükenince
 * AI yanıt vermiyor. Kullanıcının bunu ancak mesaj gönderdiğinde öğrenmesi kötü bir
 * sürpriz; kalan pay başlıkta sürekli duruyor.
 *
 * Sınırsız kurulumda çubuk çizilmiyor: dolmayan bir çubuk bilgi taşımıyor.
 */
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib/cn';
import { useAiStore } from '../model/aiStore';

const formatter = new Intl.NumberFormat('tr-TR', { notation: 'compact', maximumFractionDigits: 1 });

export function AiQuotaBar() {
  const { t } = useTranslation();
  const quota = useAiStore((s) => s.quota);
  if (!quota) return null;

  if (quota.unlimited) {
    return <span className="text-fg-subtle text-[11px]">{t('ai.unlimited')}</span>;
  }

  const limit = Math.max(quota.limit, 1);
  const usedPct = Math.min(100, Math.round((quota.used / limit) * 100));
  const low = quota.remaining <= limit * 0.1;

  return (
    <span className="flex items-center gap-1.5">
      <span className="bg-bg-muted h-1 w-16 overflow-hidden rounded-full">
        <span
          className={cn('block h-full rounded-full transition-all', low ? 'bg-danger' : 'bg-brand-500')}
          style={{ width: `${usedPct}%` }}
        />
      </span>
      <span className={cn('text-[11px]', low ? 'text-danger' : 'text-fg-subtle')}>
        {t('ai.remainingTokens', { count: quota.remaining, formatted: formatter.format(quota.remaining) })}
      </span>
    </span>
  );
}
